<template>
  <FadeSlideDownUp v-if="open">
    <section class="modal">
      <button class="modal__close" type="button" @click="closeModal">
        <component
          :is="'decline'"
        />
      </button>
      <Hero
        v-if="hero && hero.image"
        :image="hero.image"
        class="color--dark"
      />
      <Logo :class="`hero__logo  color--${textColor ? textColor.value : 'dark'}`" />
      <div class="modal__content" :style="contentPadding">
        <Heading
          v-if="heading"
          :title="heading"
          level="h2"
        />
        <Wysiwyg
          v-if="content"
          :content="content"
        />
        <div :class="{container: !fullScreen}">
          <slot />
        </div>
      </div>
    </section>
  </FadeSlideDownUp>
</template>

<script>

import * as components from '@/icons'
import FadeSlideDownUp from '@/components/transitions/FadeSlideDownUp.vue'
import Hero from '@/sections/section-header/SectionHeader.vue'
import Heading from '@/components/heading/Heading.vue'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'
import Logo from '@/icons/Logo'

let timer
let scrollY

export default {
  components: {
    ...components,
    Hero,
    FadeSlideDownUp,
    Heading,
    Wysiwyg,
    Logo
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    hero: {
      type: [Object, Boolean],
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: [String, Boolean],
      default: false
    },
    fullScreen: {
      type: [Boolean],
      default: false
    }
  },
  computed: {
    contentPadding () { return this.noPadding ? {padding: 0} : {} }
  },
  watch: {
    open (newVal) {
      if(newVal) {
        this.onOpen()
      } else {
        this.onClose()
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    onOpen () {
      timer = setTimeout(() => {
        scrollY = window.scrollY
        const body = document.body
        // body.style.position = 'fixed'
        // body.style.overflow = "hidden"
        // body.style.height = "100%"
      }, 800)

    },
    onClose () {
      if (timer) {
        clearTimeout()
      }
      const body = document.body
      // console.log('scrollY', scrollY)
      // body.style.position = ''
      // body.style.overflow = "auto"
      // body.style.height = "auto"
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  z-index: 20;
  top: 0;
  background: $modal-background-color;
  width: 100%;
  max-width: 600px;
  height: 100vh;
  height: -webkit-fill-available;
  overflow-y: scroll;
  &__close {
    position: fixed;
    z-index: 1;
    top: $modal-button-top;
    right: $modal-button-right;
    display: flex;
    justify-content: center;
    align-items: center;
    width: $modal-button-size;
    height: $modal-button-size;
    background: $modal-button-background;
    color: $modal-button-icon-color;
    border-radius: 50%;
    svg {
      width: $default-icon-width;
      height: $default-icon-height;
    }
  }
  &__content {
    padding: $modal-content-padding;
  }

  .container {
    margin-top: 20px;
  }

  .hero__logo {
    width: 12%;
  }

}
</style>

<docs>
  ## Disclaimer
  Do noooooot add the style attribute, this is only for documentation purposes.
  ```jsx
  let isModalOpen = false

  <div style="min-height: 400px">
    <Modal
            :open="isModalOpen"
            :hero="{image: {url: 'https://picsum.photos/200/300'}}"
            heading="Title for modal"
            @closeModal="() => isModalOpen = !isModalOpen"
            style="position: relative;">
          <div>
            <h3>Nog een title</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Consectetur libero id faucibus nisl tincidunt eget nullam non nisi. Nisi quis eleifend quam adipiscing vitae proin sagittis nisl. Neque viverra justo nec ultrices dui sapien eget mi. Viverra mauris in aliquam sem. Pharetra convallis posuere morbi leo urna. Ipsum faucibus vitae aliquet nec ullamcorper sit amet risus nullam. Tincidunt augue interdum velit euismod in pellentesque massa placerat. Pharetra pharetra massa massa ultricies. Fermentum odio eu feugiat pretium. Habitant morbi tristique senectus et netus. Mauris pellentesque pulvinar pellentesque habitant morbi tristique senectus et netus. Eleifend mi in nulla posuere. Sed blandit libero volutpat sed. Varius vel pharetra vel turpis nunc eget lorem dolor sed. Bibendum neque egestas congue quisque. In mollis nunc sed id semper risus in hendrerit. </p>
          </div>
    </Modal>
    <div>
      <Button
              @click.native="() => isModalOpen = !isModalOpen"
              :text="isModalOpen ? 'Close Modal' : 'Open Modal'"
              type="button"
              icon-right="location"
              button-background="dark"
              button-color="light"
      />

    </div>
  </div>

  ```
</docs>
